export default (fns) => {
  const uniqueFns = [...new Set(fns)];
  uniqueFns.forEach((fn) => fn());
};
